import React from "react";
import { Box, IconButton, MenuItem, TextField } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import type { DeveloperGuideCodeSample } from "../../types";

interface DeveloperGuideCodeSampleEditorProps {
  sample: DeveloperGuideCodeSample;
  onChange: (sample: DeveloperGuideCodeSample) => void;
  onRemove: () => void;
  disabled?: boolean;
}

const LANGUAGES = ["curl", "javascript", "typescript", "python", "java", "go", "text"];

const DeveloperGuideCodeSampleEditor: React.FC<
  DeveloperGuideCodeSampleEditorProps
> = ({ sample, onChange, onRemove, disabled }) => (
  <Box
    sx={{
      border: "1px solid",
      borderColor: "divider",
      borderRadius: 1,
      p: 2,
      mb: 1,
    }}
  >
    <Box sx={{ display: "flex", gap: 1, mb: 1 }}>
      <TextField
        select
        size="small"
        label="Language"
        value={sample.language}
        disabled={disabled}
        onChange={(e) => onChange({ ...sample, language: e.target.value })}
        sx={{ minWidth: 140 }}
      >
        {LANGUAGES.map((lang) => (
          <MenuItem key={lang} value={lang}>
            {lang}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        size="small"
        label="Label"
        fullWidth
        disabled={disabled}
        value={sample.label}
        onChange={(e) => onChange({ ...sample, label: e.target.value })}
      />
      <IconButton aria-label="Remove code sample" onClick={onRemove} disabled={disabled}>
        <DeleteOutlineIcon />
      </IconButton>
    </Box>
    <TextField
      fullWidth
      multiline
      minRows={4}
      label="Code"
      disabled={disabled}
      value={sample.code}
      onChange={(e) => onChange({ ...sample, code: e.target.value })}
      InputProps={{ sx: { fontFamily: "monospace", fontSize: "0.85rem" } }}
    />
  </Box>
);

export default DeveloperGuideCodeSampleEditor;
